import Vue from "vue";
import VueRouter from "vue-router";
import Landing from "../views/Landing.vue";
import Consent from "../views/Consent.vue";
import Live from "../views/Live.vue";
import SMMRequired from "../views/SMMRequired.vue";
import EventBase from "../components/EventBase.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Landing",
    component: Landing
  },
  {
    path: "/:id",
    component: EventBase,
    children: [
      {
        path: "/",
        name: "landing",
        component: Landing
      },
      {
        path: "consent",
        name: "consent",
        component: Consent
      },
      {
        path: "smmrequired",
        name: "smmrequired",
        component: SMMRequired
      },
      {
        path: "live",
        name: "live",
        component: Live
      }
      /*
      {
        path: 'embed',
        name: 'embed',
        component: Embed
      },
      {
        path: 'speaker',
        name: 'speaker',
        component: Speaker
      }
      */
    ]
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
